import { HourlyRate } from "@tm/context-distribution"
import { TmaEventTracking } from "../.."
import { mapHourlyRatesToRepairTimesChanged } from "./helper"

export const RepairTimesChangedEventHelper = {
    Call: async (hourlyRates: HourlyRate[], translateText: (key: number | string) => string) => {
        TmaEventTracking.dispatchTrack({
            tmaEvent: "REPAIRTIMES_CHANGED",
            action: "repairtimes_changed_called",
            bundle: "general",
            component: "repository",
            payload: { repairTimeList: mapHourlyRatesToRepairTimesChanged(hourlyRates, translateText) },
            source: "general",
            type: "click",
        })
    },
}
